import { BaseService } from "@services/BaseService";

interface TemplatePayload {
  name: string;
  description: string;
  prompt: string;
  template_type: string | null;
  company_id?: number | null;
}

class TemplateService extends BaseService {
  createTemplate(data: TemplatePayload) {
    return this.post("/projects/templates", data);
  }

  getTemplateById(templateId: string) {
    return this.get(`/projects/templates/${templateId}`);
  }

  updateTemplate(templateId: string, data: TemplatePayload) {
    return this.patch(`/projects/templates/${templateId}`, data);
  }

  getTemplateTypes() {
    return this.get("/projects/template-types");
  }

  getAllTemplates(params?: {
    order?: string;
    template_type?: string;
    offset?: number;
    limit?: number;
  }) {
    return this.get("/projects/templates", { params });
  }

  getMyTemplates(params?: {
    order?: string;
    template_type?: string;
    offset?: number;
    limit?: number;
  }) {
    return this.get("/projects/my_templates", { params });
  }

  deleteTemplate(templateId: number | string) {
    return this.delete(`/projects/templates/${templateId}`);
  }
  generateFromFile(file: File) {
    const formData = new FormData();
    formData.append("uploaded_file", file);

    return this.post("/projects/templates/generate", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

export const templateService = new TemplateService();
